import { api } from './client';

export interface EmailConfigDto {
  id: number;
  smtpHost: string;
  smtpPort: number;
  smtpUsername: string;
  smtpPassword: string;
  useSsl: boolean;
  fromEmail: string;
  fromName: string;
  replyToEmail: string | null;
  isConfigured: boolean;
}

export interface UpdateEmailConfigRequest {
  smtpHost?: string;
  smtpPort?: number;
  smtpUsername?: string;
  smtpPassword?: string;
  useSsl?: boolean;
  fromEmail?: string;
  fromName?: string;
  replyToEmail?: string;
}

export const emailConfigApi = {
  get: () =>
    api.get<EmailConfigDto>('/email/config'),

  update: (data: UpdateEmailConfigRequest) =>
    api.put<void>('/email/config', data),
};
